import { render, staticRenderFns } from "./higherSchoolCount.vue?vue&type=template&id=ab47dcaa&"
import script from "./higherSchoolCount.vue?vue&type=script&lang=js&"
export * from "./higherSchoolCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports